import { makeEnum } from '@transcend-io/type-utils';

/**
 * Fields to order a silo discovery result when paginating
 */
export enum SiloDiscoveryResultOrderField {
  /** The name of the recommended silo */
  Name = 'name',
  /** The sensitivity of the recommended silo */
  Sensitivity = 'sensitivity',
  /** The alphabetical order of silo names that discovered this resource */
  DiscoveredBy = 'discoveredBy',
  /** The created at date of the recommended silo discovery */
  CreatedAt = 'createdAt',
}

/**
 * The status of a classified silo discovery plugin result
 */
export const SiloDiscoveryResultStatus = makeEnum({
  /** The recommendation is pending review */
  Pending: 'PENDING',
  /** The recommendation has been ignored and will not show up for future review */
  Ignored: 'IGNORED',
  /** The recommendation has been marked as duplicate and will not show up for future review */
  Duplicate: 'DUPLICATE',
  /** The recommendation has been added to the data inventory and will not show up for future review */
  Added: 'ADDED',
});

/**
 * Type override
 */
export type SiloDiscoveryResultStatus =
  (typeof SiloDiscoveryResultStatus)[keyof typeof SiloDiscoveryResultStatus];

/**
 * The status of whether a particular data silos holds sensitive data
 */
export const ContainsSensitiveData = makeEnum({
  /** There is a likely personal data in this tool */
  /** Maps to Yes or LIKELY in catalogs hasPersonalData field  */
  Likely: 'LIKELY',
  /** It is unlikely that this tool has personal data  */
  /** Maps to NO or UNLIKELY in catalogs hasPersonalData field  */
  Unlikely: 'UNLIKELY',
  /** Unknown whether there is personal data or not */
  /** Maps to UNSPECIFIED or empty in catalogs hasPersonalData field  */
  Unknown: 'UNKNOWN',
});

/** Type override */
export type ContainsSensitiveData =
  (typeof ContainsSensitiveData)[keyof typeof ContainsSensitiveData];
